import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { IconGeo } from 'blocket-ui'

import { getSingleDropdownRegionOptions } from 'utils/geo'
import GeoDropdown from '../GeoDropdown'

const StyledIconGeo = styled(IconGeo)`
  position: absolute;
  pointer-events: none;
  left: 14px;
  top: 16px;
`
const StyledGeoDropdown = styled(GeoDropdown)`
  padding-left: 41px;
`

const SingleDropdown = ({ regionParameter, onChange, className, geoPreference }) => {
  const options = getSingleDropdownRegionOptions(regionParameter)

  const handleRegionChange = (e, newValue) => {
    onChange({ r: newValue })
  }

  const id = 'GeoDropdown'
  return (
    <StyledGeoDropdown
      onChange={handleRegionChange}
      value={geoPreference.r || ''}
      id={id}
      options={options}
      aria-label={regionParameter.selectionHeaderLabel}
      data-cy="geo-picker"
      className={className}
    >
      <StyledIconGeo width="16px" height="16px" color="#696766" />
    </StyledGeoDropdown>
  )
}

SingleDropdown.propTypes = {
  regionParameter: PropTypes.object.isRequired,
  geoPreference: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.string,
}

export default SingleDropdown
